/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordUserFieldComponent } from '../../admin/form/form-record/fields/user/form-record-user-field.component';
/* eslint-enable */

export class FormRecordUserFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordUserFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
